export enum EnumEstadoJanelaBusca {
  maximizado = 0,
  resultadoBuscaSimples = 1,
  resultadoBuscaAvancada = 2,
  resultadoBuscaAvancadaMinimizado = 3,
}
